import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectState } from '../../../selectors';
import { setCurrentOfferPage } from '../../../store/offer';
import { stepNames } from '../../../lib/side-effects/progress-bar';
import IntegrationDetailsPanel from './integration-details-panel';
import Ioss from './ioss';
import { Pages } from '../../../../shared/types/offers';
import FreeTrialReview from './free-trial';
const ReviewOrder = () => {
    const { offer: { offerFlow }, } = useSelector(selectState);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.ReviewOrder));
        dispatch(setProgressBarCurrentStep(stepNames.reviewOrder));
    }, []);
    switch (offerFlow) {
        case 'add-integration':
            return React.createElement(IntegrationDetailsPanel, null);
        case 'ioss':
            return React.createElement(Ioss, null);
        case 'free-trial':
            return React.createElement(FreeTrialReview, null);
        default:
            return null;
    }
};
export default ReviewOrder;
